/** Attachment identity/content comparison ignores the regenerated presentation order. */
export function normalizeAttachmentCell(value: unknown): unknown {
  if (!value || typeof value !== 'object') {
    return null;
  }

  return Object.entries(value as Record<string, unknown>)
    .map(([blobId, file]) => {
      const entry =
        file && typeof file === 'object'
          ? (file as Record<string, unknown>)
          : {};
      return {
        blobId,
        id: entry.id,
        name: entry.name,
        mime: entry.mime,
        size: entry.size,
      };
    })
    .sort((left, right) => left.blobId.localeCompare(right.blobId));
}
